import { useCallback, useState } from 'react'
import Navbar from '@/components/Navbar'
import Hero from '@/components/Hero'
import Calculator from '@/components/Calculator'
import MealPlanner from '@/components/MealPlanner'
import WorkoutBuilder from '@/components/WorkoutBuilder'
import SeoContent from '@/components/SeoContent'
import Faq from '@/components/Faq'
import Footer from '@/components/Footer'
import { calculateShred } from '@/lib/shred'
import { generateMeals } from '@/lib/plans'
import type { ShredResults } from '@/lib/shred'
import type { Meal } from '@/lib/plans'

// Compute stable initial defaults once (avoids null-check flash)
const DEFAULT_RESULTS: ShredResults = calculateShred({
  gender: 'male',
  units: 'imperial',
  weightLbs: 185,
  heightCm: 180,
  age: 28,
  useBodyFat: false,
  bodyFat: 18,
  activity: 'moderate',
  goal: 'balanced',
})
const DEFAULT_MEALS: Meal[] = generateMeals(DEFAULT_RESULTS)

function Home() {
  const [results, setResults] = useState<ShredResults>(DEFAULT_RESULTS)
  const [meals, setMeals] = useState<Meal[]>(DEFAULT_MEALS)

  const handleResults = useCallback((r: ShredResults, m: Meal[]) => {
    setResults(r)
    setMeals(m)
  }, [])

  return (
    <div className="min-h-screen bg-[#0a0c10] text-slate-200 antialiased">
      <Navbar />
      <main>
        <Hero />
        <Calculator onResults={handleResults} />
        <MealPlanner
          meals={meals}
          dailyCalories={results.dailyCalories}
          totalProtein={results.protein}
        />
        <WorkoutBuilder />
        <SeoContent />
        <Faq />
      </main>
      <Footer />
    </div>
  )
}

export default Home
